import API from './api';

export async function uploadToCloudinary(file, folder = 'listings') {
  const { data } = await API.get(`/cloudinary/signature?folder=${folder}`);
  const form = new FormData();
  form.append('file', file);
  form.append('api_key', data.api_key);
  form.append('timestamp', data.timestamp);
  form.append('signature', data.signature);
  form.append('folder', data.folder);
  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${data.cloud_name}/image/upload`,
    { method: 'POST', body: form }
  );
  const result = await res.json();
  if (result.error) throw new Error(result.error.message);
  return result.secure_url;
}
